import * as Utils from './utils';
import * as Header from './header.js';
import * as CTA from './cta.js';
import * as IncludedMovies from './included-movies';
import * as TitleDetails from './title-details';
import * as Footer from './footer';
import * as Tracking from './tracking';
import * as i18n from './i18n';



// Base paths for TMDb image sources
// see https://developers.themoviedb.org/3/getting-started/images
const URL_TMDB_IMG_ORIGINAL = 'https://image.tmdb.org/t/p/original'
const URL_TMDB_IMG_W500 = 'https://image.tmdb.org/t/p/w500'

let LANG;


// Check if index.html DOM has been loaded
let isDOMContentLoaded = false;

// Check if index.html assets have been loaded
let isLoaded = false;


// IIFEEeeeeee. Not needed in Webpack??
// (() => {

console.log('IIFEEeeeeee');
const PATH_CONFIG = './config.json';
let CONFIG;
let isConfigDataFed = false;


// Load config JSON files
const loadConfigFiles = () => {
    Utils.loadAndParseJSON(PATH_CONFIG)
        .then(res => {
            // console.log(res);
            CONFIG = res;

            return;
        })
        .then(() => {
            //  Once config is loaded. get language file
            return i18n.load(CONFIG.language);
        })
        .then(() => {
            // Once the HTML is populated with designated language, fill/replace with config.
            feedConfigData(CONFIG);
        })

}



/**
 * Populate contents based on config.json
 * @param {Object} C 
 */
const feedConfigData = C => {
    if (isConfigDataFed) {
        return;
    }

    if (!isDOMContentLoaded) {
        return;
    }

    console.log('feedConfigData ', C);

    // <title>
    Header.replaceHtmlTitle(C.title, C["message-extra"]);

    Header.addExtraMessage(C["message-extra"]);

    // Header Exit URL
    Header.setHeaderExit(C.exits.header);

    // "Purchase Now" button exit URL
    Header.setPurchaseNowExit(C.exits['purchase-now']);


    // // Set YouTube ID
    // youtube_videoId = C.youtube;

    // Retailers
    CTA.renderRetailers(C.retailers);


    // Set URLs for Step 1 - 3
    CTA.setStepExits(C);

    // Poster wall under "Bonus Movies Included in Offer" section
    IncludedMovies.renderIncludedMoviePosters(C.posters);


    // Add Overview text
    TitleDetails.renderOverviewText(C.overview);

    // Add Casts and Crews
    TitleDetails.renderCredits(C.credits);

    // Add Ratings
    TitleDetails.renderRatings(C.mpaa);

    // Add Runtime
    TitleDetails.renderRuntime(C.runtime);

    // Add Release Year
    TitleDetails.renderYear(C.year);

    // Add Release Year
    TitleDetails.setRottenTomatoes(C.rottentomatoes);

    // Write T&C
    Footer.renderLegal(C.legal);

    // "Need Help?" link 
    Footer.setHelpUrl(C.exits.help);

    // Privacy Policy link
    Footer.setPrivacyPolicyUrl(C.exits.privacy);

    // T&C link
    Footer.setTermsUrl(C.exits.terms);

    // Everything with .title class attached will have Movie/Show title within.
    Utils.setTitlesInText(C.title);

    // Set years
    Utils.setYears();

    //--------------------------
    // Show contents. finally.
    showContents();



    //--------------------------
    // Init Google Analytics
    Tracking.initGA();


    isConfigDataFed = true;
}




/**
 * Unlock body wrapper #hide-until-loaded
 */
const showContents = () => {
    document.querySelector('#hide-until-loaded').classList.add('loaded');
}





/**
 * DOMContentLoaded bootstrapper
 * @param {*} e 
 */
const onDOMContentLoaded = (e) => {
    isDOMContentLoaded = true;
    // Kick start with config.JSON + language file
    loadConfigFiles();


    // Data feeding for backup 
    // feedConfigData(CONFIG);
    // i18n.feedLanguageData(LANG);
}



/**
 * Load bootstrapper, event handler
 * @param {*} e 
 */
const onLoad = (e) => {
    isLoaded = true;
    setTimeout(() => {
        TitleDetails.initYouTube(CONFIG.youtube);
        Header.setHeaderParallax(CONFIG.header);
    }, 1000);

}


/**
 * Check for protocol. Fwd to HTTPS if it's not secured.
 * Give exception for local dev environment.
 */
const checkAndForwardToHttps = () => {
    if (location.protocol === 'http:'
        && location.href.indexOf('127.0.0.1') === -1 
        && location.href.indexOf('localhost') === -1) {
        window.location = `https://${location.host}${location.pathname}`;
    }
}

checkAndForwardToHttps();

// window.DOMContentLoaded listener
window.addEventListener('DOMContentLoaded', onDOMContentLoaded)

// window.load listener
window.addEventListener('load', onLoad);

